module.exports = __webpack_public_path__ + "img/Chopra.cdcfff62.png";